const state = {
  userIdNameMap: {}
};

const getters = {
  getUserIdNameMap(state) {
    return state.userIdNameMap;
  }
};

const mutations = {
  setUserIdNameMap(store, data) {
    const userList = data.body[0].results;
    let resultArray = {};
    for (let property in userList) {
      if (!store.userIdNameMap.hasOwnProperty(property)) {
        resultArray[property] = userList[property];
      }
    }
    store.userIdNameMap = { ...store.userIdNameMap, ...resultArray };
  },
  setUserIdNameMapNotInSystem(store, userIdData) {
    let userList = {};

    userIdData.forEach(userId => {
      if (userId === 'serviceaccount') {
        userList[userId] = {
          email: [],
          firstName: 'Developement Account',
          id: '',
          lastName: '',
          middleName: ''
        };
        return;
      }
      const validator = 'idNotInSystem';
      const user = userId.split(validator);
      const firstName = user[1].startsWith('usernameAtSource')
        ? user[1].split('_')[1]
        : 'User not found';
      userList[userId] = {
        email: [],
        firstName: firstName ? firstName : 'User not found',
        id: '',
        lastName: '',
        middleName: ''
      };
    });
    store.userIdNameMap = { ...store.userIdNameMap, ...userList };
  }
};

const actions = {
  async SET_USER_MAP({ commit }, { data }) {
    commit('setUserIdNameMap', data);
  },
  async SET_USER_MAP_NOT_IN_SYSTEM({ commit }, data) {
    commit('setUserIdNameMapNotInSystem', data);
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
